import { IdleReminderAdmin } from '../../../components/src/lib/IdleReminder/IdleReminderAdmin';
import { ReduxStore, useActions, keepingAliveAdmin } from '@trip-ux/redux-store';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { labelsSelector } from './utils';
import { Progress } from '@trip-ux/components';

export const SessionContainerAdmin: FC<{
  countDownSeconds: number;
  homePage: string;
}> = ({ countDownSeconds, homePage }) => {
  const { labels } = useSelector((store: ReduxStore) => ({
    labels: labelsSelector(store)
  }));
  const actions = useActions({ keepingAliveAdmin });

  // If translations / config haven't loaded yet, show a loading state so the page waits
  if (!labels || !(labels as any).session_container) {
    return <Progress />;
  }

  const sessionLabels = (labels as any).session_container;

  return (
    <IdleReminderAdmin
      countDownSeconds={countDownSeconds}
      refresh={() => {
        actions.keepingAliveAdmin();
      }}
      labels={sessionLabels}
    />
  );
};

SessionContainerAdmin.displayName = 'SessionContainerAdmin';
export default SessionContainerAdmin;
